import fundamentals from "../components/Content/config.js";
import html from "../components/ContentHtml/config.js";
 

export const courseRegistry = {
  fundamentals,
  html,
/*   python,
  js,
  seo,
  smm, */
}
 